import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { GameDetailsComponent } from './game-details.component';
import { CarouselComponent } from "src/app/components/carousel/carousel.component";

@NgModule({
  declarations: [
    GameDetailsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ComponentsModule,
    CarouselComponent
  ]
})
export class GameDetailsModule { }
